var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick Square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Tick-Square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick-Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5601 1.99988C19.9501 1.99988 22.2201 4.37988 22.2201 7.91988V16.0909C22.2201 19.6199 19.9501 21.9999 16.5601 21.9999H7.89014C4.50014 21.9999 2.22014 19.6199 2.22014 16.0909V7.91988C2.22014 4.37988 4.50014 1.99988 7.89014 1.99988H16.5601ZM16.4001 8.99988C16.0601 8.65988 15.5001 8.65988 15.1601 8.99988L11.0301 13.1299L9.28014 11.3799C8.94014 11.0399 8.38014 11.0399 8.04014 11.3799C7.70014 11.7199 7.70014 12.2699 8.04014 12.6199L10.4201 14.9899C10.5901 15.1599 10.8101 15.2399 11.0301 15.2399C11.2601 15.2399 11.4801 15.1599 11.6501 14.9899L16.4001 10.2399C16.7401 9.89988 16.7401 9.34988 16.4001 8.99988Z",
    fill: "#D9D9D9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/Tick Square.69d7faeaa27c34a3c6599b7a7b18383c.svg";
export { ForwardRef as ReactComponent };